import React from 'react';
import styled, { css } from 'styled-components';

export interface GridProps {
  /**
   * 열간격
   */
  colGap?: number;
  /**
   * 행간격
   */
  rowGap?: number;
  /**
   * 열 갯수
   */
  colSize: number;
  className?: string;
  children?: React.ReactNode;
}

/**
 * Grid 형태의 컬럼을 나타낼떄 사용
 * @author 이현우
 * @param param0
 * @returns
 */
const Grid = ({
  children,
  colGap = 8,
  rowGap = 8,
  colSize,
  ...props
}: GridProps) => {
  return (
    <Box {...props}>
      <Container colGap={colGap} rowGap={rowGap} colSize={colSize}>
        {children}
      </Container>
    </Box>
  );
};

export default Grid;

const Box = styled.div`
  width: 100%;
`;

const Container = styled.div<{
  colGap?: number;
  rowGap?: number;
  colSize: number;
}>`
  ${({ colGap = 8, rowGap = 8, colSize }) => css`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;

    > * {
      width: calc((100% - ${colGap * (colSize - 1)}px) / ${colSize}) !important;
      margin-bottom: ${rowGap}px;
      margin-right: ${colGap}px;
    }
    > *:nth-child(${colSize}n) {
      margin-right: 0;
    }

    > *:nth-last-child(-n + ${colSize}) {
      margin-bottom: 0;
    }
  `}
`;
